<script setup lang="ts">
import { resetState } from '@/composables/messages';

resetState();
</script>

<template>
  <div></div>
</template>